import React, { useState, useEffect } from 'react';
import { Button } from '../../common';
import { Checkbox, Separator } from '../../common/form';
import t from '../../i18n/I18n';
import HashMap from '../../protocol/HashMap';
import SaveSettings from '../../queries/settings/SaveSettings';
import { ThemeSetup } from '../../themes/ThemeSetup';
import { checkDirecoryExisting, directorySelector, unregisterListner } from '../../util/MainThreadUtil';
import StringUtil, { swapArrayLocs } from '../../util/StringUtil';
import ConfirmModal from '../../modals/confirm/ConfirmModal';
import ToolTip from '../../common/AssetPropertyView';
import './MediaStore.css';
import { last } from 'lodash';
import Modal2 from '../../modals/Modal2';
import { TextWithEllipsisFileExtension } from '../../common/TextWithEllipsis';

const TPM_VARS = {
  ACTIVE_ID: null,
  KEY_CONST: 'THIRD_PARTY_MOUNT_POINT',
  SUFFIX: 0,
  KEY_AUTO: 'THIRD_PARTY_MOUNT_POINT_auto',
  KEY_DELETE_ALL: 'delete_THIRD_PARTY_MOUNT_POINT'
};

const MediaStore = () => {
  const [mediaStors, setmediaStors] = useState([]);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [deleteAll, setDeleteAll] = useState(false);
  const [alreadyExistPath, setAlreadyExistPath] = useState([]);
  useEffect(() => {
    setTPMObject(SaveSettings.TPM_PATHS_SETTINGS_CACHE);
  }, []);

  const setTPMObject = (tpmPaths) => {
    const paths = [];
    let isAnyDefault = false;
    tpmPaths.keys().forEach((e: string) => {
      const path = tpmPaths.get(e);
      const isDefault = e.toLowerCase().endsWith('default') ? true : e.endsWith('default_RO') ?  true : false;
      const isReadOnly = e.endsWith('_RO');
      if (!isAnyDefault) isAnyDefault = isDefault;
      paths.push({ id: e, value: path, isDefault, isExist: true, isReadOnly: isReadOnly });
    });
    // if (!isAnyDefault && paths.length) {
    //   paths[0].isDefault = true;
    //   paths[0].id = `${paths[0].id}_default`;
    // }
    paths.sort(StringUtil.createSortFn('value'));
    const defaultIndex = paths.findIndex((e) => e.isDefault);
    defaultIndex > -1 ? swapArrayLocs(paths, defaultIndex, 0) : '';
    setmediaStors(paths);
    checkDirecoryExisting(
      paths.map((e) => e.value),
      (existingPaths) => checkPathExisting(paths, existingPaths)
    );
  };

  const checkPathExisting = (paths, existingPaths) => {
    if (existingPaths && existingPaths.length) {
      const items = [...paths];
      items.forEach((e) => {
        e.isExist = existingPaths.includes(e.value);
      });
      setmediaStors(items);
    }
  };

  const onReset = () => {
    setTPMObject(SaveSettings.TPM_PATHS_SETTINGS_CACHE);
    // setTimeout(() => {
    //   checkDirecoryExisting(
    //     mediaStors.map((e) => e.value),
    //     (existingPaths) => checkPathExisting(mediaStors, existingPaths)
    //   );
    // }, 2000);
  };

  const onClickAdd = () => {
    const items = [...mediaStors];
    const lastItem = last(items);
    if (lastItem && !lastItem.value) return;
    TPM_VARS.SUFFIX++;
    let newId = `${TPM_VARS.KEY_AUTO}${TPM_VARS.SUFFIX}`;
    while (SaveSettings.TPM_PATHS_SETTINGS_CACHE.get(newId)) {
      TPM_VARS.SUFFIX++;
      newId = `${TPM_VARS.KEY_AUTO}${TPM_VARS.SUFFIX}`;
    }

    items.push({
      id: `${newId}`,
      value: '',
      isDefault: items.length ? false : true
    });
    setmediaStors(items);
  };

  const onDeleteClick = (id) => {
    setShowConfirm(id);
  };

  const onConfirmDelete = () => {
    const items = [...mediaStors];
    const item = items.splice(
      items.findIndex((e) => e.id === showConfirm),
      1
    );
    if (items.length) {
      if (item[0].isDefault) {
        items[0].isDefault = true;
      }
    } else if (item) {
      setDeleteAll(true);
    }
    setmediaStors(items);
    setShowConfirm(false);
  };

  const onApplyChanges = () => {
    const mediaStorsMap = new HashMap();
    const mediaStorsItems = mediaStors.filter((e) => e.value);
    // if (!mediaStorsItems.length) return;
    let alreadyDefault = mediaStorsItems.find((e) => e.id.toLowerCase().includes('default'));
    if (alreadyDefault) {
      alreadyDefault.id = alreadyDefault.id.replace('_default', '');
    }
    mediaStorsItems.map((e) =>{ 
      if(e.id.includes('_RO')) {
        e.id =  e.id.replace('_RO', '');
      }
      return e;
    });
    const defaultItem = mediaStorsItems.find((e) => e.isDefault);
    if (defaultItem) {
      if(defaultItem.id.includes('_RO')) {
        defaultItem.id.replace('_RO', '');
        defaultItem.id = defaultItem.id + '_default';
      } else {
        defaultItem.id = defaultItem.id + '_default';
      }
    }
    
  mediaStorsItems.map(e=> {
      if(e.isReadOnly) {
        e.id = e.id + '_RO';
      } 
      return e;
    });

    mediaStorsItems.forEach((e) => {
      mediaStorsMap.put(e.id, e.value);
    });
    if (deleteAll) {
      if (mediaStorsMap.size() == 0) {
        mediaStorsMap.put(TPM_VARS.KEY_DELETE_ALL, 'true');
      }
      setDeleteAll(false);
    }
    SaveSettings.saveTPMSettings(mediaStorsMap).then(() => {
      mediaStorsMap.remove(TPM_VARS.KEY_DELETE_ALL);
      setTPMObject(mediaStorsMap);
      setShowConfirm(false);
    }).catch(error=>{ 
      const paths: Array = error.errorDetails.split(',');
      setAlreadyExistPath(paths);
      setShowConfirm(false);
      setShowAlert(true);
    });
  };

  const onCloseAlert = () => {
  setAlreadyExistPath([]);
  setShowAlert(false);
  setDeleteAll(false);
 };

  return (
    <div name="MediaStore">
      <Separator />
      <div className="row">
        <div className="col-12 m-2 d-flex">
          <Button
            icon={ThemeSetup.getImageURL('add_asset_red.svg')}
            text={t('NEW_MEDIA_STORE')}
            title={t('NEW_MEDIA_STORE')}
            onClick={onClickAdd}
            className="mr-4"
          />
          <Button
            icon={ThemeSetup.getImageURL('download_asset.svg')}
            text={t('APPLY_CHANGES')}
            title={t('APPLY_CHANGES')}
            onClick={()=>setShowConfirm(true)}
          />
          <Button title={t('RESET')} style={{ position: 'absolute', right: '40px' }} onClick={onReset}>
            <i className="fa fa-repeat" style={{ marginRight: '5px' }} aria-hidden="true"></i>
            {t('RESET')}
          </Button>
        </div>
      </div>
      <Separator />
      <MediaStoreList items={mediaStors} checkPathExisting={checkPathExisting} onDeleteClick={onDeleteClick} />
      {showConfirm ? (
        <div className="confirm">
          <ConfirmModal
            onClose={() => setShowConfirm(false)}
            message={!isNaN(showConfirm) ? t('SAVE_MEDIA_STORE') : t('DELETE_MEDIA_STORE')}
            moveAsset={!isNaN(showConfirm) ? onApplyChanges : onConfirmDelete}
          />
        </div>
      ) : null}
      {showAlert ? <Modal2 
      title={t('FOLLOWING_MEDIA_STORE_PATH_ALREADY_EXIST')}
      buttons= {[{label: t('DONE_LABEL'), onClick: ()=>onCloseAlert(), type: 'PRIMARY' }]}
      onClose = {()=>onCloseAlert()}>
        {alreadyExistPath.map((value, index)=>{
            return <TextWithEllipsisFileExtension key={index} title={value} text={value} isFolder={true}>
              </TextWithEllipsisFileExtension>; 
          })}
      </Modal2>: null}

    </div>
  );
};

const MediaStoreList = ({ items, onDeleteClick, checkPathExisting }) => {
  const [activeId, setActiveId] = useState(null);
  const setValue = (index, value) => {
    items[index].value = value;
    setActiveId(new Object());
    checkDirecoryExisting(
      items.map((e) => e.value),
      (existingPaths) => checkPathExisting(items, existingPaths)
    );
  };

  const onDefaultClick = (index) => {
    const defaultIndex = items.findIndex((e) => e.isDefault);
    if (defaultIndex !== index) {
      defaultIndex > -1 ? (items[defaultIndex].isDefault = false) : '';
      items[index].isDefault = true;
    } else {
      items[index].isDefault = false;
    }

    setActiveId(new Object());
  };

  const onReadOnlyClick = (index)=> {
    items[index].isReadOnly = !items[index].isReadOnly;
    setActiveId(new Object());
  };

  const onFileSelect = async (paths) => {
    if (paths && paths.length) {
      setValue(TPM_VARS.ACTIVE_ID, paths[0]);
    }
  };

  const FileSelector = (path: string) => {
    directorySelector(onFileSelect, {name: 'MEDIA_STORE', path: path});
  };

  return (
    <div className="row">
      <div className="col-12">
        {items.map((e, i) => (
          <MediaStoreListItem
            {...e}
            key={e.id}
            index={i}
            setActive={setActiveId}
            setValue={setValue}
            isActive={e.id === activeId}
            onDefaultClick={onDefaultClick}
            onDeleteClick={onDeleteClick}
            FileSelector={FileSelector}
            onReadOnlyClick={onReadOnlyClick}
          />
        ))}
      </div>
    </div>
  );
};

const MediaStoreListItem = ({
  value,
  id,
  index,
  isDefault,
  isActive,
  setActive,
  setValue,
  onDefaultClick,
  onDeleteClick,
  FileSelector,
  isExist,
  isReadOnly,
  onReadOnlyClick
}) => {
  const [inputValue, setInput] = useState(value);
  useEffect(() => {
    if (value !== inputValue) {
      setInput(value);
    }
  }, [value]);
  useEffect(() => {
    setInput(value);
  }, [value]);

  const onFocus = (path: string) => {
    TPM_VARS.ACTIVE_ID = index;
    FileSelector(path);
  };
  const showDeleteIcon = id.indexOf(TPM_VARS.KEY_CONST) > -1;
  return (
      <div className="row mt-2 align-items-center" style={isExist ? {} : { opacity: '0.4' }}>
        <div className="col-1 d-flex">
          <span className={'mr-3 minus-icon'}>
            {showDeleteIcon ? (
              <Button
                icon={ThemeSetup.getImageURL('minus.svg')}
                title={t('DELETE_MEDIA_STORE_PATH')}
                onClick={() => onDeleteClick(id)}
              />
            ) : null}
          </span>

          <span>
            <ToolTip text={isExist ? t('MEDIA_STORE_CONNECTED') : t('MEDIA_STORE_DISCONNECTED')}>
              <Button
                icon={
                  isExist ? ThemeSetup.getImageURL('folder_gray.svg') : ThemeSetup.getImageURL('folder_open_expand.svg')
                }
                onClick={() => {}}
              />
            </ToolTip>
          </span>
        </div>

        <div className="col-6 media-input" onClick={() => onFocus(inputValue)}>
          <input type="text" placeholder={t('Click_TO_ADD_PATH')} value={inputValue} readOnly={true} />
        </div>

        <div className="col-2">
            <Checkbox
              checked={isReadOnly}
              label={isReadOnly ? 'Read Only' : ''}
              tooltip={!isReadOnly ? t('SET_READ_ONLY_MEDIA_STORE'): null}
              onChange={() => onReadOnlyClick(index)}
            />
        </div>
       
        <div className="col-3">
          {isExist ? (
            <Checkbox
              checked={isDefault}
              label={isDefault ? 'Default Media Store' : ''}
              tooltip={!isDefault ? t('SET_DEFAULT_MEDIA_STORE'): null}
              onChange={() => onDefaultClick(index)}
            />
          ) : null}
        </div>
      </div>
  );
};

export default MediaStore;
